import { render } from "./NewWorkflowStepModal.vue?vue&type=template&id=3b607466"
import script from "./NewWorkflowStepModal.vue?vue&type=script&lang=js"
export * from "./NewWorkflowStepModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__